export class ArticlePlausiPropertyDef {

  public static readonly IS_LEFT_SIDE_OPEN: string = 'isLeftSideOpen';
  public static readonly IS_RIGHT_SIDE_OPEN: string = 'isRightSideOpen';
  public static readonly IS_IO_750_753: string = 'isIO_750_753';
  public static readonly MAX_CURRENT_FOR_BUS_MODULES: string = 'maxCurrentForBusModules';
  public static readonly MOUNTING_FOOT: string = 'Montagefuss';
  public static readonly MOUNTING_TYPE: string = 'Mountingtype';
  public static readonly MOUNTING_TYPE_VALUE_FLANGE: string = 'Flansch';
  public static readonly MOUNTING_TYPE_VALUE_SNAP_FOOT: string = 'Rastfuss';
  public static readonly IST_PE_KLEMME: string = 'ist_PE_Klemme';
  public static readonly IST_N_KLEMME: string = 'ist_N_Klemme';
  public static readonly MCS_GDS_STACKABLE: string = 'McsGdsStackable';
}
